import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const CountDisplay = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  min-width: 24px;
  text-align: center;
`;